module.exports = __webpack_public_path__ + "static/media/suspend.391b0d8e.svg";